import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Divider,
  Select,
  MenuItem,
  FormControl,
  InputLabel
} from '@mui/material';

const businessTypes = [
  { value: 'all', label: 'All Businesses' },
  { value: 'restaurant', label: 'Restaurants' },
  { value: 'bar', label: 'Pubs' },
  { value: 'lodging', label: 'Hotels' }
];

const VenueDetailsModal = ({ venue, open, onClose, onSearchNearby }) => {
  const [selectedType, setSelectedType] = useState('all');
  console.log("VenueDetailsModal",venue);
  if (!venue) return null;

  // Determine if this is a lead or account venue
  const isLead = venue.name && !venue.venue_name;
  const venueName = venue.venue_name || venue.name;
  const venueAddress = venue.address || venue.vicinity || '';
  
  // For leads, get location from data.geometry.location
  let venueLat = venue.latitude;
  let venueLng = venue.longitude;
  if (isLead && venue.data?.geometry?.location) {
    venueLat = venue.data.geometry.location.lat;
    venueLng = venue.data.geometry.location.lng;
  }

  const handleSearch = () => {
    if (onSearchNearby && venueLat && venueLng) {
      onSearchNearby({
        type: selectedType,
        latitude: venueLat,
        longitude: venueLng,
        venueName: venueName
      });
    }
  };

  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        <Typography variant="h6">{venueName}</Typography>
       
      </DialogTitle>
      <DialogContent>
        <Box sx={{ mb: 3 }}>
          <Typography variant="body1" gutterBottom>
            Venue Details
          </Typography>
          <Typography variant="subtitle2" color="text.secondary">
            {venueAddress}{venue.zone_name ? `, ${venue.zone_name}` : ''}
          </Typography>
          <Divider sx={{ my: 1 }} />
          {venue.phone && (
            <Typography variant="body2" color="text.secondary" gutterBottom>
              Phone: {venue.phone}
            </Typography>
          )}
          {venue.rating && (
            <Typography variant="body2" color="text.secondary" gutterBottom>
              Rating: {venue.rating} ({venue.user_ratings_total} reviews)
            </Typography>
          )}
          {venue.deposit_region && (
            <Typography variant="body2" color="text.secondary">
              Region: {venue.deposit_region}
            </Typography>
          )}
          {venue.zone_name && (
            <Typography variant="body2" color="text.secondary">
              Zone: {venue.zone_name}
            </Typography>
          )}
        </Box>

        {onSearchNearby && venueLat && venueLng && (
          <Box sx={{ mt: 2 }}>
            <FormControl fullWidth sx={{ mb: 2 }}>
              <InputLabel>Business Type</InputLabel>
              <Select
                value={selectedType}
                label="Business Type"
                onChange={(e) => setSelectedType(e.target.value)}
              >
                {businessTypes.map(type => (
                  <MenuItem key={type.value} value={type.value}>
                    {type.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Button 
              variant="contained" 
              fullWidth 
              onClick={handleSearch}
            >
              Find Nearby Businesses
            </Button>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => console.log('Add notes')} color="primary">
          Add Notes
        </Button>
        <Button onClick={() => console.log('Set reminder')} color="primary">
          Set Reminder
        </Button>
        <Button onClick={onClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default VenueDetailsModal;